import axios from "axios";

const togglePreferredBy = (genericItemId) => {
  return axios.post(`/generic-item/toggle-is-preferred/${genericItemId}`);
};

export default {
  togglePreferredBy
};